import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { disconnectWhatsApp } from '@/services/whatsapp.service';
import { sanitizeSupabaseError } from '@/lib/errorHandler';

export function useDisconnectWhatsApp() {
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  return useMutation({
    mutationFn: disconnectWhatsApp,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['whatsapp-channel'] });
      toast.success(t('settings.whatsapp.disconnectedToast'));
    },
    onError: (err) => {
      toast.error(sanitizeSupabaseError(err));
    },
  });
}
